import { PopupWrapper } from "./styles";
import { Div } from "../common/ui/widgets";
export const Popup = ({ closePopup, children }) => {
  return (
    <PopupWrapper data-testid="popup-wrapper">
      <Div 
      data-testid="closePopup"
      onClick={closePopup} />
      {children}
    </PopupWrapper>
  );
};
